import { render, staticRenderFns } from "./ArticleTileHeader.vue?vue&type=template&id=0061a622&scoped=true"
import script from "./ArticleTileHeader.vue?vue&type=script&lang=ts"
export * from "./ArticleTileHeader.vue?vue&type=script&lang=ts"
import style0 from "./ArticleTileHeader.vue?vue&type=style&index=0&id=0061a622&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "0061a622",
  null
  
)

export default component.exports